import api from "./axios";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
export const getClients = () => api.get("/clients");
export const getClient = (id) => api.get(`/clients/${id}`);


// export const updateClient = (id, data) => api.put(`/clients/${id}`, data);
// export const deleteClient = (id) => api.delete(`/clients/${id}`);

// export const createClient = async (data) => {
//   try {
//     const res = await axios.post(`${apiUrl}/clients`, data);
//     console.log("Client créé :", res.data);
//     return res.data;
//   } catch (ex) {
//     console.error("Erreur lors de la création :", ex.response ? ex.response.data : ex);
//   }
// };

export const createClient = async (data) => {
  try {
    const res = await axios.post(`${apiUrl}/clients`, data);
    console.log("Client créé :", res.data);

    if (!res.data?.id) {
      throw new Error("Client renvoyé invalide depuis le backend !");
    }

    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la création :", ex.response ? ex.response.data : ex);
    throw ex; // 🔥 relancer l'erreur pour que le frontend handleAddClient la capture
  }
};
export const updateClient = async (id, data) => {
  try {
    const res = await axios.put(`${apiUrl}/clients/${id}`, data);
    console.log("Client mise à jour :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la mise à jour :", ex.response ? ex.response.data : ex);
  }
};
export const deleteClient  = async (id) => {
  try {
    const res = await axios.delete(`${apiUrl}/clients/${id}`);
    console.log("Client bien supprime :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la suprision :", ex.response ? ex.response.data : ex);
  }
};